module.exports = __webpack_public_path__ + "static/tony-packos-0633d6c08c63f2fb5b7385b9785128f8.png";